import WorkHistoryLayer from './work-history-layer.view';
export default WorkHistoryLayer;
